import { useEffect, type ReactNode } from "react";

type Props = {
  message: string;
  onDismiss: () => void;
  durationMs?: number;
  variant?: "success" | "error" | "info";
};

const VARIANT_CLASS: Record<NonNullable<Props["variant"]>, string> = {
  success: "border-green-100 bg-green-50 text-green-600",
  error: "border-rose-100 bg-rose-50 text-rose-500",
  info: "border-blue-100 bg-blue-50 text-blue-500",
};

export function Toast({ message, onDismiss, durationMs = 2200, variant = "success" }: Props) {
  useEffect(() => {
    const id = window.setTimeout(onDismiss, durationMs);
    return () => window.clearTimeout(id);
  }, [onDismiss, durationMs]);

  return (
    <div
      role="status"
      aria-live="polite"
      className="pointer-events-none fixed inset-x-0 top-4 z-[100] flex justify-center px-4"
    >
      <div
        className={`pointer-events-auto inline-flex items-center gap-2 rounded-full border px-4 py-2 text-sm font-semibold shadow-lg ${VARIANT_CLASS[variant]}`}
      >
        {message}
      </div>
    </div>
  );
}

export function ToastHost({ children }: { children: ReactNode }) {
  return <>{children}</>;
}
